export { fastMemo } from "./fastMemo.js";